function hideScreen1()
{  
    // document.getElementById("imageTarget").style.display="none";
    // document.getElementById("image1").style.display="none";
    // document.getElementById("wordTarget").style.display="none";
    // document.getElementById("word1").style.display="none";
    stimContainers[0].style.display="none";
    stimContainers[1].style.display="none";
}